import styled from 'styled-components';
import { breakpoints } from '@exo/frontend-common-theme-utils';
import theme from './PageHeading.theme';

export const PageHeading = styled('div')`
& .pageHeading {
    font: ${props => theme(props).fontMobile};

    ${breakpoints.greaterThan('medium')`
        font: ${props => theme(props).font};
      `}
  }
`;


